<section class="notif-panel">
    <header class="notif-panel__header">
        <div class="notif-panel__title-row">
            <h5 class="notif-panel__title">Notificaciones</h5>
            @if (noLeidas > 0) {
                <span class="notif-badge" [attr.aria-label]="noLeidas + ' sin leer'">{{ noLeidas }}</span>
            }
        </div>
        <small class="notif-panel__subtitle">Últimas notificaciones</small>
    </header>

    <ul class="notif-list" role="list">
        <li *ngFor="let notif of notificacionesLimitadas" role="listitem" class="notif-card" [class.notif-card--unread]="!notif.visto">
            <div class="notif-card__icon" [ngClass]="tipoColorClass(notif.tipo)">
                <i [ngClass]="tipoIcono(notif.tipo)"></i>
            </div>

            <div class="notif-card__body">
                <div class="notif-card__title-row">
                    <span class="notif-card__title">{{ notif.titulo }}</span>
                    @if (!notif.visto) {
                        <span class="notif-card__dot" aria-hidden="true"></span>
                    }
                </div>
                <p class="notif-card__text">{{ notif.texto }}</p>
                <div class="notif-card__footer">
                    <span class="notif-card__time">{{ notif.fecha_hora | date: 'short' }}</span>
                    <button
                        type="button"
                        class="notif-card__toggle"
                        [class.notif-card__toggle--unread]="!notif.visto"
                        (click)="marcarComoLeida(notif)"
                        [attr.aria-label]="notif.visto ? 'Marcar como no leída' : 'Marcar como leída'"
                    >
                        <i [ngClass]="notif.visto ? 'pi pi-replay' : 'pi pi-check'"></i>
                        {{ notif.visto ? 'No leída' : 'Leída' }}
                    </button>
                </div>
            </div>
        </li>
    </ul>

    @if (notificacionesLimitadas.length === 0) {
        <div class="notif-empty">
            <i class="pi pi-bell notif-empty__icon"></i>
            <p class="notif-empty__text">No hay notificaciones</p>
        </div>
    }

    <footer class="notif-panel__footer">
        @if (noLeidas > 0) {
            <button type="button" class="notif-panel__link" (click)="marcarTodasLeidas()">
                <i class="pi pi-check-square"></i>
                Marcar todas como leídas
            </button>
        }
        <button type="button" class="notif-panel__link notif-panel__link--primary" (click)="verTodas()">
            Ver todas
            <i class="pi pi-arrow-right"></i>
        </button>
    </footer>
</section>
